export enum StructureNodeActionTypes {
    Add = 1,
    Update = 2,
    Remove = 3,
    RemoveFromItemState = 4,
    MoveTogether = 5,
    MoveAlone = 6,
    ToggleEnabled = 6,
}